import { AcademicLevel, Availabilities, CampaignId, Consentement, Email, FirstName, LastName, MobilePhoneRequired, Salutation, SlotId } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...CampaignId,
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired
  }),
  ...SlotId
})

export default schema
